import React from 'react';
import { Image, User, Globe, Eye, MessageSquare, AlertCircle } from 'lucide-react';

const Toggle = ({ icon: Icon, label, hint, checked, onChange, testId }) => (
  <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
    <div className="flex items-center gap-3">
      <Icon size={20} className="text-gray-600" />
      <div>
        <p className="font-medium text-gray-800">{label}</p>
        <p className="text-xs text-gray-500">{hint}</p>
      </div>
    </div>
    <button
      type="button"
      data-testid={testId}
      onClick={onChange}
      className={`relative w-14 h-7 rounded-full transition-colors ${checked ? 'bg-green-500' : 'bg-gray-300'}`}
    >
      <span className={`absolute top-1 left-1 w-5 h-5 bg-white rounded-full transition-transform ${checked ? 'translate-x-7' : ''}`} />
    </button>
  </div>
);

const BlogSEOTab = ({ formData, setFormData }) => (
  <div className="space-y-5">
    <div>
      <label className="block text-sm font-bold text-gray-700 mb-2">Title Tag</label>
      <input
        type="text"
        data-testid="seo-title-input"
        value={formData.seo_title || ''}
        onChange={(e) => setFormData((prev) => ({ ...prev, seo_title: e.target.value }))}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder={formData.title || 'SEO optimized title...'}
      />
      <p className="mt-1 text-xs text-gray-500">{(formData.seo_title || formData.title || '').length}/60 characters (recommended)</p>
    </div>

    <div>
      <label className="block text-sm font-bold text-gray-700 mb-2">Meta Description</label>
      <textarea
        data-testid="seo-description-input"
        value={formData.seo_description || ''}
        onChange={(e) => setFormData((prev) => ({ ...prev, seo_description: e.target.value }))}
        rows={3}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="A compelling description for search results..."
      />
      <p className="mt-1 text-xs text-gray-500">{(formData.seo_description || '').length}/155 characters (recommended)</p>
    </div>

    <div>
      <label className="block text-sm font-bold text-gray-700 mb-2">
        <Image size={14} className="inline mr-2" />Featured Image Alt Text
      </label>
      <input
        type="text"
        data-testid="seo-alt-text-input"
        value={formData.featured_image_alt || ''}
        onChange={(e) => setFormData((prev) => ({ ...prev, featured_image_alt: e.target.value }))}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="Describe the featured image for accessibility..."
      />
    </div>

    <div>
      <label className="block text-sm font-bold text-gray-700 mb-2">
        <User size={14} className="inline mr-2" />Author Display Name
      </label>
      <input
        type="text"
        data-testid="seo-author-display-input"
        value={formData.author_display || ''}
        onChange={(e) => setFormData((prev) => ({ ...prev, author_display: e.target.value }))}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="Author name shown on the post"
      />
    </div>

    <Toggle
      icon={Globe}
      label="Index Status"
      hint="Let search engines index this page"
      checked={formData.is_indexable !== false}
      onChange={() => setFormData((prev) => ({ ...prev, is_indexable: !prev.is_indexable }))}
      testId="seo-toggle-index"
    />
    <Toggle
      icon={Eye}
      label="Show Views"
      hint="Display view count on the blog post"
      checked={formData.show_views !== false}
      onChange={() => setFormData((prev) => ({ ...prev, show_views: !prev.show_views }))}
      testId="seo-toggle-views"
    />
    <Toggle
      icon={MessageSquare}
      label="Show Comments"
      hint="Allow and display comments on this post"
      checked={formData.show_comments !== false}
      onChange={() => setFormData((prev) => ({ ...prev, show_comments: !prev.show_comments }))}
      testId="seo-toggle-comments"
    />
    <Toggle
      icon={AlertCircle}
      label="Rich Results"
      hint="Enable structured data (JSON-LD) for rich snippets"
      checked={formData.enable_rich_results !== false}
      onChange={() => setFormData((prev) => ({ ...prev, enable_rich_results: !prev.enable_rich_results }))}
      testId="seo-toggle-rich-results"
    />
  </div>
);

export default BlogSEOTab;
